import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import "firebase/auth";
import { GoogleAuthProvider, getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCvMH45e6D-gbMHLSH5ds0ZIqZxvcUV3WU",
  authDomain: "profilewebsite-450f7.firebaseapp.com",
  databaseURL:
    "https://profilewebsite-450f7-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "profilewebsite-450f7",
  storageBucket: "profilewebsite-450f7.appspot.com",
  messagingSenderId: "899443422274",
  appId: "1:899443422274:web:8c942fe5217800d659a9db",
  measurementId: "G-4FL5XH88HV",
  // : process.env.REACT_APP_APIKEY,
  // : process.env.REACT_APP_AUTHDOMAIN,
  // : process.env.REACT_APP_DATABASEURL,
  // : process.env.REACT_APP_PROJECTID,
  // : process.env.REACT_APP_STORAGEBUCKET,
  // : process.env.REACT_APP_MESSAGINGSENDERID,
  // : process.env.REACT_APP_APPID,
  // : process.env.REACT_APP_MEASUREMENTID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
export const db = getFirestore(app);
export const oth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
